<template>
  <div
    :class="getSidebarClass()"
  >
    <CSidebarBrand
      @mouseup="$store.commit('updateSidebar','1')"
      @mouseover="$store.commit('updateSidebar','1')">
      <a href="https://trophylab.com/" target="_blank"><img class="d-block" width="35" height="35" :src="trophylab_symbol" /></a>
      <div class="px-2 sidebar-brand-full">
        <a href="https://trophylab.com/" target="_blank" class="text-white text-decoration-none">TrophyLab.com</a>
      </div>
    </CSidebarBrand>

    <CSidebarNav
      v-if="menuNav !== []"
      @click="$store.commit('updateSidebar','1')"
    >
      <CNavGroup
        v-for="item in menuNav"
        :key="item"
        :ref="'upMenuSn'+item.upMenuSn"
        :visible="isActiveLinkGroup(item)"
        @mouseup="$store.commit('updateSidebar','1')"
      >
        <template #togglerContent>
          <CIcon  customClassName="nav-icon" :icon="item.icon"
                  @mouseup="$store.commit('updateSidebar','1')"
                  @mouseover="$store.commit('updateSidebar','1')"
          />{{item.name}}
        </template>
        <CNavItem
          v-for="subitem in item.items"
          :key="subitem">

          <CNavLink :class="(this.isActiveLink(subitem.to))?'active':''" style="cursor: pointer"
                    @click="routerPush(subitem.to)">{{subitem.name}}</CNavLink>
        </CNavItem>
      </CNavGroup>
    </CSidebarNav>

    <CSidebarFooter @click="$store.commit('toggleUnfoldable')">
      <div class="w-100 d-block table-align-center fw-bold">
        <template v-if="$store.state.sidebarUnfoldableFix">
        <font-awesome-icon :icon="['fas', 'right-long']" size="lg" />&nbsp;메뉴 고정
        </template>
        <template v-else>
          <font-awesome-icon :icon="['fas', 'left-long']" size="lg" />&nbsp;메뉴 접기
        </template>
      </div>
    </CSidebarFooter>
<!--    <AppSidebarNav-->
<!--      @mouseup="$store.commit('updateSidebar','1')"-->
<!--      @mouseover="$store.commit('updateSidebar','1')"-->
<!--      @mouseout="$store.commit('updateSidebar','2')"-->
<!--    />-->

  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
// eslint-disable-next-line no-unused-vars
import trophylab_symbol from '@/assets/images/trophylab/trophylab_symbol-removebg.png'
import {useRoute} from "vue-router";
// import {AppSidebarNav} from "@/components/AppSidebarNav";

export default {
  name: 'AppSidebar',
  components: {
    // AppSidebarNav
  },
  methods : {
    normalizePath:function(path) {
        return decodeURI(path)
          .replace(/#.*$/, '')
          .replace(/(index)?\.(html)$/, '')
    },
    isActiveLinkGroup:function(item) {
      // if(item.visible) return true;
      for (let i = 0; i < item.items.length; i++) {
        const subitem = item.items[i];
        if(this.isActiveLink(subitem.to)) {
          // item.visible = true;
          return true;
        }
      }
      return false;
    },
    checkAtiveLinkGroup:function(item) {
      for (let j = 0; j < this.menuNav.length; j++) {
        let items = this.menuNav[j].items;
        if(items.upMenuSn != item.upMenuSn) {
          items.visible = false;
          // console.log(this.$refs.get('upMenuSn'+items.upMenuSn));
        }
      }

      item.visible = !item.visible;
      //   this.menuNav[j].visible = false;
      //   if (isFirst) {
      //     for (let i = 0; i < items.length; i++) {
      //       const subitem = items[i];
      //       if (this.isActiveLink(subitem.to)) {
      //         this.menuNav[j].visible = true;
      //       }
      //     }
      //   }
      // }
    },
    isActiveLink:function(link) {

      if (link === undefined) {
        return false
      }

      if (this.route.hash === link) {
        return true
      }

      const currentPath = this.normalizePath(this.route.path)
      const targetPath = this.normalizePath(link)

      return currentPath === targetPath
    },
    getSidebarClass:function() {
      let classNames = [];
      classNames.push('sidebar')
      classNames.push('sidebar-fixed')
      classNames.push('sidebar-sm')

      if(this.sidebarVisible) {
        classNames.push('show')
      } else {
        classNames.push('hide')
      }

      if(this.sidebarUnfoldable && this.sidebarUnfoldableFix) {
        classNames.push('sidebar-narrow-unfoldable-new')
      }

      return classNames.join(' ');
    },
    routerPush:function(path){
      // console.log(path);
      this.moveCnt++;
      this.$router.push({path: path, query: { '':this.moveCnt }})
    },
  },
  created() {

    // setTimeout(()=>{
    //   this.isActiveLinkGroup(true);
    // }, 1000);

    // console.log('test1');
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    let moveCnt = 0;
    // console.log(route);
    // console.log('test0');

    return {
      sidebarUnfoldableFix: computed(() => store.state.sidebarUnfoldableFix),
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
      menuNav : computed(() => store.state.menuNav),
      trophylab_symbol,
      route,
      moveCnt,
    }
  },
  beforeUpdate() {
    // console.log('test3');
    // this.checkAtiveLinkGroup(true);
  },
  beforeMount() {
    // const sidebar = document.getElementsByClassName('sidebar');
    //  console.log('test2');
  }
}
</script>
<style>
.sidebar-narrow-unfoldable-new {
  position: fixed;
  z-index: 1031;
  flex: 0 0 var(--cui-sidebar-narrow-width);
  width: var(--cui-sidebar-narrow-width);
  padding-bottom: var(--cui-sidebar-toggler-height);
  overflow: visible;

  &:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 4rem;
  }
  &.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 4rem;
  }
  &.sidebar.sidebar-sm:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 4rem;
  }


  &.sidebar-fixed {
    z-index: 1031;
    width: var(--cui-sidebar-narrow-width);
  }
  .sidebar-brand-full {
    display: none;
  }
  .sidebar-brand-narrow {
    display: block;
  }
  .d-narrow-none,
  .nav-label,
  .nav-title,
  .nav-group-items,
  .nav-group.show .nav-group-items,
  .sidebar-footer,
  .sidebar-form,
  .sidebar-header {
    height: 0 !important;
    padding: 0;
    margin: 0;
    visibility: hidden;
    opacity: 0;
  }
  .sidebar-toggler {
    position: fixed;
    bottom: 0;

    &::before {
      @include ltr-rtl("transform", rotate(-180deg), null, rotate(0deg));
    }
  }
  &.sidebar-end .sidebar-toggler::before {
    transform: rotate(0deg);
  }
}

</style>
